var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useCallback } from "react";
import { Profile, TFile } from "@brg/api";
import { bProfile, useProfile } from "@brg/auth";
export var uploadValidator = function (files, toasts, isWideImageType, profile, additionalValidate) { return __awaiter(void 0, void 0, void 0, function () {
    var isModer, failedChecks, loadFile, _a, height, width, ratio, MAX_JPEG_FILE_SIZE, MAX_GIF_FILE_SIZE, MAX_PNG_FILE_SIZE, failedSize, failedDimensions, failedRatio;
    var _b, _c, _d, _e, _f, _g, _h, _j;
    return __generator(this, function (_k) {
        switch (_k.label) {
            case 0:
                if ((files === null || files === void 0 ? void 0 : files.length) === 0 || !profile)
                    return [2 /*return*/, true];
                isModer = bProfile.isModer(profile);
                failedChecks = {};
                loadFile = function () {
                    return new Promise(function (resolve, reject) {
                        var fr = new FileReader();
                        fr.onload = function () {
                            // file is loaded
                            var img = new Image();
                            img.onload = function () {
                                var width = img.width, height = img.height;
                                resolve({
                                    width: width,
                                    height: height
                                });
                            };
                            // @ts-ignore
                            img.src = fr.result; // is the data URL because called with readAsDataURL
                        };
                        // @ts-ignore
                        fr.readAsDataURL(files[0]);
                    });
                };
                return [4 /*yield*/, loadFile()];
            case 1:
                _a = _k.sent(), height = _a.height, width = _a.width;
                if ((height >= width && (height > 5262 || width > 3720)) ||
                    (width > height && (height > 3720 || width > 5262))) {
                    toasts.error('Максимальные размеры изображения - 3720х5262 и 5262x3720');
                    failedChecks.dimensions = true;
                }
                ratio = width / height;
                if (isWideImageType) {
                    // const isSmallWideImage = ratio > 1.47 && ratio < 1.49
                    // const isLargeWideImage = ratio > 1.79 && ratio < 1.81
                    // if (!isSmallWideImage && !isLargeWideImage) {
                    //   toasts.error(
                    //     'Изображение неправильное (отношение ширины к высоте должно быть или 1.48, или 1.8)'
                    //   )
                    //   failedChecks.ratio = true
                    // }
                }
                else {
                    if (ratio < 0.6) {
                        toasts.error('Изображение слишком длинное (отношение ширины к высоте должно быть 0.6 и более)');
                        failedChecks.ratio = true;
                    }
                    if (additionalValidate) {
                        if (ratio < 0.6 || ratio > 0.8) {
                            toasts.error("Изображение должно быть вертикальным (отношение ширины к высоте от 0.6 до 0.8");
                            failedChecks.ratio = true;
                        }
                    }
                }
                MAX_JPEG_FILE_SIZE = 157286400;
                MAX_GIF_FILE_SIZE = 20971520;
                MAX_PNG_FILE_SIZE = 20971520;
                if (
                // @ts-ignore
                (((_b = files === null || files === void 0 ? void 0 : files[0]) === null || _b === void 0 ? void 0 : _b.type) === 'image/jpeg' || ((_c = files === null || files === void 0 ? void 0 : files[0]) === null || _c === void 0 ? void 0 : _c.type) === 'image/jpg') && ((_d = files === null || files === void 0 ? void 0 : files[0]) === null || _d === void 0 ? void 0 : _d.size) > MAX_JPEG_FILE_SIZE) {
                    toasts.error('Максимальный размер jpeg-файла - 150Мб');
                    failedChecks.size = true;
                }
                if (
                // @ts-ignore
                (((_e = files === null || files === void 0 ? void 0 : files[0]) === null || _e === void 0 ? void 0 : _e.type) === 'image/png') && ((_f = files === null || files === void 0 ? void 0 : files[0]) === null || _f === void 0 ? void 0 : _f.size) > MAX_PNG_FILE_SIZE) {
                    toasts.error('Максимальный размер png-файла - 20Мб');
                    failedChecks.size = true;
                }
                if (
                // @ts-ignore
                ((_g = files === null || files === void 0 ? void 0 : files[0]) === null || _g === void 0 ? void 0 : _g.type) === 'image/gif' && ((_h = files === null || files === void 0 ? void 0 : files[0]) === null || _h === void 0 ? void 0 : _h.size) > MAX_GIF_FILE_SIZE) {
                    toasts.error('Максимальный размер gif-файла - 20Мб');
                    failedChecks.size = true;
                }
                if (!__spreadArray(['image/jpeg', 'image/jpg', 'image/gif', 'image/png'], (isModer ? ['image/png'] : []), true).includes((_j = files === null || files === void 0 ? void 0 : files[0]) === null || _j === void 0 ? void 0 : _j.type)) {
                    toasts.error('Допустимые форматы: jpg, png, gif');
                    failedChecks.size = true;
                }
                failedSize = failedChecks.size, failedDimensions = failedChecks.dimensions, failedRatio = failedChecks.ratio;
                if (failedSize || failedDimensions || failedRatio) {
                    return [2 /*return*/, false];
                }
                return [2 /*return*/, true];
        }
    });
}); };
var useUploadValidator = function () {
    var profile = useProfile();
    var toasts = useToasts();
    return useCallback(function (files) {
        return uploadValidator(files, toasts, false, profile);
    }, [profile]);
};
export default useUploadValidator;
//# sourceMappingURL=useUploadValidator.js.mapvar __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useCallback } from "react";
import { Profile, TFile } from "@brg/api";
import { bProfile, useProfile } from "@brg/auth";
export var uploadValidator = function (files, toasts, isWideImageType, profile, additionalValidate) { return __awaiter(void 0, void 0, void 0, function () {
    var isModer, failedChecks, loadFile, _a, height, width, ratio, MAX_JPEG_FILE_SIZE, MAX_GIF_FILE_SIZE, MAX_PNG_FILE_SIZE, failedSize, failedDimensions, failedRatio;
    var _b, _c, _d, _e, _f, _g, _h, _j;
    return __generator(this, function (_k) {
        switch (_k.label) {
            case 0:
                if ((files === null || files === void 0 ? void 0 : files.length) === 0 || !profile)
                    return [2 /*return*/, true];
                isModer = bProfile.isModer(profile);
                failedChecks = {};
                loadFile = function () {
                    return new Promise(function (resolve, reject) {
                        var fr = new FileReader();
                        fr.onload = function () {
                            // file is loaded
                            var img = new Image();
                            img.onload = function () {
                                var width = img.width, height = img.height;
                                resolve({
                                    width: width,
                                    height: height
                                });
                            };
                            // @ts-ignore
                            img.src = fr.result; // is the data URL because called with readAsDataURL
                        };
                        // @ts-ignore
                        fr.readAsDataURL(files[0]);
                    });
                };
                return [4 /*yield*/, loadFile()];
            case 1:
                _a = _k.sent(), height = _a.height, width = _a.width;
                if ((height >= width && (height > 5262 || width > 3720)) ||
                    (width > height && (height > 3720 || width > 5262))) {
                    toasts.error('Максимальные размеры изображения - 3720х5262 и 5262x3720');
                    failedChecks.dimensions = true;
                }
                ratio = width / height;
                if (isWideImageType) {
                    // const isSmallWideImage = ratio > 1.47 && ratio < 1.49
                    // const isLargeWideImage = ratio > 1.79 && ratio < 1.81
                    // if (!isSmallWideImage && !isLargeWideImage) {
                    //   toasts.error(
                    //     'Изображение неправильное (отношение ширины к высоте должно быть или 1.48, или 1.8)'
                    //   )
                    //   failedChecks.ratio = true
                    // }
                }
                else {
                    if (ratio < 0.6) {
                        toasts.error('Изображение слишком длинное (отношение ширины к высоте должно быть 0.6 и более)');
                        failedChecks.ratio = true;
                    }
                    if (additionalValidate) {
                        if (ratio < 0.6 || ratio > 0.8) {
                            toasts.error("Изображение должно быть вертикальным (отношение ширины к высоте от 0.6 до 0.8");
                            failedChecks.ratio = true;
                        }
                    }
                }
                MAX_JPEG_FILE_SIZE = 157286400;
                MAX_GIF_FILE_SIZE = 20971520;
                MAX_PNG_FILE_SIZE = 20971520;
                if (
                // @ts-ignore
                (((_b = files === null || files === void 0 ? void 0 : files[0]) === null || _b === void 0 ? void 0 : _b.type) === 'image/jpeg' || ((_c = files === null || files === void 0 ? void 0 : files[0]) === null || _c === void 0 ? void 0 : _c.type) === 'image/jpg') && ((_d = files === null || files === void 0 ? void 0 : files[0]) === null || _d === void 0 ? void 0 : _d.size) > MAX_JPEG_FILE_SIZE) {
                    toasts.error('Максимальный размер jpeg-файла - 150Мб');
                    failedChecks.size = true;
                }
                if (
                // @ts-ignore
                (((_e = files === null || files === void 0 ? void 0 : files[0]) === null || _e === void 0 ? void 0 : _e.type) === 'image/png') && ((_f = files === null || files === void 0 ? void 0 : files[0]) === null || _f === void 0 ? void 0 : _f.size) > MAX_PNG_FILE_SIZE) {
                    toasts.error('Максимальный размер png-файла - 20Мб');
                    failedChecks.size = true;
                }
                if (
                // @ts-ignore
                ((_g = files === null || files === void 0 ? void 0 : files[0]) === null || _g === void 0 ? void 0 : _g.type) === 'image/gif' && ((_h = files === null || files === void 0 ? void 0 : files[0]) === null || _h === void 0 ? void 0 : _h.size) > MAX_GIF_FILE_SIZE) {
                    toasts.error('Максимальный размер gif-файла - 20Мб');
                    failedChecks.size = true;
                }
                if (!__spreadArray(['image/jpeg', 'image/jpg', 'image/gif', 'image/png'], (isModer ? ['image/png'] : []), true).includes((_j = files === null || files === void 0 ? void 0 : files[0]) === null || _j === void 0 ? void 0 : _j.type)) {
                    toasts.error('Допустимые форматы: jpg, png, gif');
                    failedChecks.size = true;
                }
                failedSize = failedChecks.size, failedDimensions = failedChecks.dimensions, failedRatio = failedChecks.ratio;
                if (failedSize || failedDimensions || failedRatio) {
                    return [2 /*return*/, false];
                }
                return [2 /*return*/, true];
        }
    });
}); };
var useUploadValidator = function () {
    var profile = useProfile();
    var toasts = useToasts();
    return useCallback(function (files) {
        return uploadValidator(files, toasts, false, profile);
    }, [profile]);
};
export default useUploadValidator;
//# sourceMappingURL=useUploadValidator.js.map